// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + {"151":"aos","301":"splide","390":"clamp","675":"lazy","933":"pannellum"}[chunkId] + ".min.js";
};